import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import axios from 'axios'

import { height } from "@mui/system";
import { p1, p2, p3 } from "~/assets";
import Typography from "@mui/material/Typography";
import Box from "@material-ui/core/Box";
import { SkillsBiteLogo } from "~/assets";
import { Twitterlogo } from "~/assets";
import { MLogo } from "~/assets";
import { Smilylogo } from "~/assets";
import {linkedin} from "~/assets"
import { Telegramlogo, linked, discordFooter, telegramFooter, mediuimFooter, twitterFooter } from "~/assets";
import TextField from "@mui/material/TextField";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import {Link} from 'react-scroll'
import pdf from '../../assets/whitepaper.pdf'

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [notification, setNotification]= useState({
    type: '',
    message:'',
    color:''
  })

  const [loading, setLoading] = useState(false)

  const handleChange = (e: any) => {
    setEmail(e.target.value)
  }

  function validateEmail(input: string) {
    const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (input.match(regex)) {
      return true;
    } else {
      return false;
    }
  }

  const showNotification = (type:string, message:string, color:string) => {
    setNotification({
      type:type,
      message:message,
      color:color
    })
    const clear = setTimeout(()=> 
    setNotification({ type: '', message:'',color:''}),
    3000
    )
    return () => clearTimeout(clear)
  } 

  function subscribeToMail() {
    if (validateEmail(email) == false) {
      return showNotification(
        "Error: ",
        "Enter a valid email address",
        "red"
      );
    }
    setLoading(true);
    const data= {
      email_address: email,
      merge_fields: {
        FNAME: "",
        LNAME: "",
      },
    };
    axios
      .post(`https://skillsbite.io/api/subscribe`, 
      data, 
      {
      headers:{
        'Content-Type': 'application/json',  
      }}
      )
      .then((response) => {
        console.log(response);
        setEmail("");
        //Success
        showNotification("", "Success!", "green");
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response.data);
        setLoading(false);
        //Already Subscribed
        if (err.response.data == "Member Exists") {
          setEmail("");
          showNotification("", "Already Subscribed!", "blue");
        } else {
          showNotification(
            "Error: ",
            "Unexpected Error Occurred. Try Again!",
            "red"
          );
        }
      });
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      bgcolor="#141420"
      paddingY={10}
      width="100%"
      alignItems='center'
      
    >
      <Box display='flex' flexDirection='column' width={{xs:'90%', md:'80%'}} maxWidth="1440px">
        <Box
          display="flex"
          alignItems="center"
          width="100%"
          justifyContent={{ xs: "start", md: "start", lg: "start" }}
        >
          <img src={SkillsBiteLogo} alt="logo"></img>
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row", lg: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "start", md: "start", lg: "start" }}
          width="100%"
        >
          <Box display="flex" flexDirection="column">
            <Box marginTop={5} width={{ xs: "100%", lg: 400 }}>
              <Typography sx={{ color: "#c6c6c6"  }} variant="body2">
                Get a guided and personalized experience with access to
                theoretical knowledge, courses, mentoring program, webinars, as
                well as practical opportunities.
              </Typography>
            </Box>
            <Box
              marginTop={5}
              display="flex"
              justifyContent={{
                xs: "flex-start",
                md: "flex-start",
                lg: "flex-start",
              }}
              alignItems="center"
            >
              <a href="https://www.linkedin.com/company/skillsbite/ ">
              <img src={linkedin} alt="logo">
              </img>
              </a>

              <a href="https://twitter.com/skillsbite_io ">
              <img
                style={{ marginLeft: "20px" }}
                src={twitterFooter}
                alt="logo"
              ></img>
              </a>

              <a href="https://medium.com/@skillsbite">
              <img 
              style={{ marginLeft: "20px" }} 
              src={mediuimFooter} alt="logo">
              </img>
              </a>

              <a href="https://t.me/+kMI8FcH5Wsg4YTJk ">
              <img
                style={{ marginLeft: "20px" }}
                src={telegramFooter}
                alt="logo"
              ></img>
              </a>

              <a href="https://discord.gg/nPpV56Rsg4 ">
              <img
                style={{ marginLeft: "20px" }}
                src={discordFooter}
                alt="logo"
              ></img>
              </a>

            </Box>
          </Box>

          <Box
            display="flex"
            marginTop={5}
            // width={400}
            marginX={{xs:0, md:5}}
            justifyContent="start"
            // alignItems="center"
            // alignItems="spcae-between"
            // bgcolor="red"
          >
            <Box>
            
            <Link
                  activeClass='active'
                  to='home'
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
            >
              <Typography sx={{ color: "#c6c6c6" }} style={{cursor:'pointer'}} variant="body2">
                Home
              </Typography>
            </Link>

            <Link
                  activeClass='active'
                  to='team'
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
            >
              <Typography
                sx={{ color: "#c6c6c6" , marginTop: "10px" }}
                variant="body2"
                style={{cursor:'pointer'}}
              >
                Team
              </Typography>
            </Link>

            <a
            style={{textDecoration:"none"}} href={pdf} target='_blank' rel='noreferrer'
            >
              <Typography
                sx={{ color: "#c6c6c6" , marginTop: "10px" }}
                variant="body2"
                style={{cursor:'pointer'}}
              >
                Whitepaper
              </Typography>
            </a>

            </Box>

            <Box marginLeft={10}>
            <Link
                  activeClass='active'
                  to='tokenomics'
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
            >
              <Typography sx={{ color: "#c6c6c6"  }} style={{cursor:'pointer'}} variant="body2">
                Tokenomics
              </Typography>

            </Link>

            <Link
                  activeClass='active'
                  to='roadmap'
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
            >
              <Typography
                sx={{ color: "#c6c6c6" , marginTop: "10px" }}
                variant="body2"
                style={{cursor:'pointer'}}
              >
                Roadmap
              </Typography>
            </Link>

            <Link
                  activeClass='active'
                  to='home'
                  spy={true}
                  smooth={true}
                  offset={500}
                  duration={1000}
            >
              <Typography
                sx={{ color: "#c6c6c6" , marginTop: "10px" }}
                variant="body2"
                style={{cursor:'pointer'}}
              >
                About us
              </Typography>
            </Link>
            </Box>
          </Box>

          <Box marginTop={{xs:10, lg:5}}>
            <Typography
              sx={{ color: "#fff", fontSize: "15px", marginBottom: "10px" }}
            >
              Subscribe to our newsletter
            </Typography>
            <TextField
              size="small"
              sx={
                {
                  width: {lg:300, xs:290},
                  "& .MuiOutlinedInput-root": {
                    "& > fieldset": { border: "none" },
                  },
                }
              }
              style={{
                background: "#000000",
                borderRadius: "10px",
                color: "#fff",
                
                height: 48,
                alignItems:'center'
              }}
              
              InputLabelProps={{style: {fontSize: 13, alignItems:'center', fontWeight: 400, color: "#c6c6c6", paddingTop: 5 } }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      sx={{
                        background:
                          "linear-gradient(180deg, #4E7DF9 0%, #7000FF 100%)",
                        color: "#fff",
                        borderRadius:'10px'
                      }}
                      onClick={subscribeToMail}
                    >
                      <PlayArrowIcon fontSize='small' />
                    </IconButton>
                  </InputAdornment>
                ),
                style:{
                  fontSize: '13px',
                  fontWeight: 400,
                  color: "#fff",
                  width: 300,
                  height: 48
                }
              }}
              // id="standard-basic"
              label="Enter address"
              value={email}
              // onChange={(e) => handleInputThrottled(e.target.value)}
              type="email"
              onChange={handleChange}
            />
            {loading?
            <Typography variant='body2'>Loading...</Typography>:""}
            <Typography variant='body2' color={notification.color}>{notification.type}{notification.message}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
